import React, { Component, Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import CustomForm from "../../../libraries/form";
import _ from "lodash";
import { ToastService } from "../../../utils/toastify";
import { CRUDFunction } from "../../../reduxCURD/container";
import "./style.css";
import { arrayToSelectOptions } from "../../../utils/arrayToSelectOptions";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import SpinnerLoader from "../../Common/SpinnerLoader";
import moment from "moment";
import { dataFormatters } from "../../../utils/dataFormatters";
import HosValidators from "../Helper/HosValidators";
import Dialog from "../../../libraries/Dialog";
import { addEditEntryTemplateFormSchema } from "./schemas/addEditEntryTemplateFormSchema";
import { StyledButtonActionsTable } from "../../Common/Buttons";
import AddHosEntries from "./AddHosEntries";
import { confirmationDialogWarningMessage, OpenConfirmationDialog } from "../../../libraries/ConfirmationDialog";

class EntryTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddEditEntryTemplateDialog: false,
      addEditEntryTemplateFormState: null,
      addEditEntryTemplateData: null,
      selectedEntryTemplateIndex: -1,
      entryTemplates: [],
      showloader: false,
      confirmationDialog: null,
      pendingChanges: false,
      hosRecords: [],
    };

    this.openAddEditDeleteEntryTemplateForm = this.openAddEditDeleteEntryTemplateForm.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.setShowLoader = this.setShowLoader.bind(this);

    this.stateChangeReducer = this.stateChangeReducer.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }

  componentDidMount() {
    this.stateChangeReducer("get-entry-templates");
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }

  componentDidUpdate(prevProps) {
    const { actionType, entryTemplate, entryTemplates } = this.props;
    if (actionType !== prevProps.actionType) {
      if (
        actionType === "ENTRYTEMPLATES_READ_REQUEST" ||
        actionType === "ENTRYTEMPLATE_CREATE_REQUEST" ||
        actionType === "ENTRYTEMPLATE_UPDATE_REQUEST" ||
        actionType === "ENTRYTEMPLATE_DELETE_REQUEST"
      ) {
        this.setShowLoader(true);
      } else if (actionType === "ENTRYTEMPLATES_READ_SUCCESS") {
        this.closeDialog();
        this.setShowLoader(false);
        this.stateChangeReducer("entry-templates-received", entryTemplates);
      } else if (
        actionType === "ENTRYTEMPLATE_CREATE_SUCCESS" ||
        actionType === "ENTRYTEMPLATE_UPDATE_SUCCESS" ||
        actionType === "ENTRYTEMPLATE_DELETE_SUCCESS"
      ) {
        if (entryTemplate && entryTemplate["error"]) {
          const { error } = entryTemplate;
          ToastService.Error("Error:", error); // An informative error message received from the server
        } else {
          // success
          this.closeDialog();
          this.stateChangeReducer("get-entry-templates");
        }
        this.setShowLoader(false);
      } else if (
        actionType === "ENTRYTEMPLATE_CREATE_FAILURE" ||
        actionType === "ENTRYTEMPLATE_UPDATE_FAILURE" ||
        actionType === "ENTRYTEMPLATES_READ_FAILURE" ||
        actionType === "ENTRYTEMPLATE_DELETE_FAILURE"
      ) {
        this.setShowLoader(false);
        this.closeDialog();
      }
    }
  }
  closeDialog() {
    this.setState({
      showAddEditEntryTemplateDialog: false,
      selectedEntryTemplateIndex: -1,
    });
  }

  /**
   * opens Hos Entry Template form in add, edit or delete states
   * @param {"create" | "edit" | "view" | "delete"} formState the state in which we need to open the form
   * @param {number} index index of the selected template
   * */
  openAddEditDeleteEntryTemplateForm(formState, index = -1) {
    const { entryTemplates } = this.state;
    if (formState === "create") {
      this.setState({
        showAddEditEntryTemplateDialog: true,
        addEditEntryTemplateFormState: "create",
        addEditEntryTemplateData: { name: "" },
        hosRecords: [],
        pendingChanges: false,
      });
    } else if (formState === "delete" || formState === "edit" || formState === "view") {
      if (index < entryTemplates.length) {
        let selectedRow = { ...entryTemplates[index] };
        this.setState({
          selectedEntryTemplateIndex: index,
          showAddEditEntryTemplateDialog: true,
          addEditEntryTemplateData: { name: selectedRow.name },
          addEditEntryTemplateFormState: formState,
          hosRecords: [...selectedRow.hosRecords],
          pendingChanges: false,
        });
      }
    }
  }

  stateChangeReducer(action, data) {
    const { createEntryTemplate, updateEntryTemplate, getEntryTemplates, deleteEntryTemplate } = this.props;
    const { entryTemplates, selectedEntryTemplateIndex, hosRecords, pendingChanges } = this.state;
    const { timezone } = this.props;
    switch (action) {
      case "add-entry-template":
        {
          let { fields } = data;
          const template = { hosRecords: hosRecords, name: fields.name, timezone: timezone };
          console.log(JSON.stringify(template));
          if (hosRecords.length === 0) {
            ToastService.Error("Error", "Template must contain atleast a single HOS record!");
            return;
          }

          createEntryTemplate && createEntryTemplate(template);
        }
        break;

      case "update-entry-template":
        {
          let { fields } = data;
          const template = { hosRecords: hosRecords, name: fields.name, timezone: timezone };
          if (hosRecords.length === 0) {
            ToastService.Error("Error", "Template must contain atleast a single HOS record!");
            return;
          }

          updateEntryTemplate && updateEntryTemplate(template, entryTemplates[selectedEntryTemplateIndex]._id);
        }
        break;
      case "delete-entry-template":
        {
          this.openAddEditDeleteEntryTemplateForm("delete", data);
        }
        break;
      case "view-entry-template":
        {
          this.openAddEditDeleteEntryTemplateForm("view", data);
        }
        break;
      case "edit-entry-template":
        {
          this.openAddEditDeleteEntryTemplateForm("edit", data);
        }
        break;
      case "confirm-delete-entry-template":
        {
          entryTemplates[selectedEntryTemplateIndex] &&
            deleteEntryTemplate &&
            deleteEntryTemplate(entryTemplates[selectedEntryTemplateIndex]);
        }
        break;
      case "get-entry-templates":
        getEntryTemplates && getEntryTemplates();
        break;
      case "entry-templates-received":
        if (Array.isArray(data)) {
          this.setState({
            entryTemplates: data,
          });
        }
        break;
      case "discard-session":
        if (pendingChanges) {
          this.setState({
            confirmationDialog: (
              <OpenConfirmationDialog
                title={languageService(`Confirm Discard`)}
                message={languageService(`Are you sure you want to discard unsaved changes for this template?`)}
                displayAddInfo={confirmationDialogWarningMessage(languageService(`Note: Unsaved changes will be permanently lost!`))}
                action="confirm-discard-session"
                cancelCallback={this.closeConfirmationDialog}
                confirmCallback={this.stateChangeReducer}
              />
            ),
          });
        } else {
          this.closeDialog();
        }
        break;
      case "confirm-discard-session":
        this.closeConfirmationDialog();
        this.closeDialog();
        break;
    }
  }

  render() {
    const { showAddEditEntryTemplateDialog, addEditEntryTemplateFormState, addEditEntryTemplateData } = this.state;
    const { entryTemplates, hosRecords, pendingChanges, confirmationDialog } = this.state;
    return (
      <div>
        <SpinnerLoader spinnerLoading={this.state.showloader} />
        {confirmationDialog}
        <UISectionHeader
          title={languageService("Add Template")}
          addPermission={true}
          addButtonTitle={languageService("Add Template")}
          addCallback={() => this.openAddEditDeleteEntryTemplateForm("create")}
        />
        <ThisTable
          tableColumns={[
            {
              Header: languageService("Template Name"),
              accessor: "name",
              id: "name",
              minWidth: 200,
            },
            {
              Header: languageService("Created by"),
              accessor: "createdBy.name",
              id: "enteredAt",
              minWidth: 150,
            },
            {
              Header: languageService("Created on"),
              accessor: "createdAt",
              id: "createdAt",
              Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
              minWidth: 150,
            },
            {
              Header: languageService("Updated on"),
              accessor: "updatedAt",
              id: "updatedAt",
              Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
              minWidth: 150,
            },
            {
              Header: languageService("Actions"),
              id: "actions",
              Cell: (d) => {
                const index = d.row._index;
                return (
                  <div>
                    <StyledButtonActionsTable title="View" onClick={() => this.stateChangeReducer("view-entry-template", index)} />
                    <StyledButtonActionsTable title="Edit" onClick={() => this.stateChangeReducer("edit-entry-template", index)} />
                    <StyledButtonActionsTable title="Delete" onClick={() => this.stateChangeReducer("delete-entry-template", index)} />
                  </div>
                );
              },
              minWidth: 100,
            },
          ]}
          tableData={entryTemplates}
          pagination={true}
          forDashboard={false}
          height={"auto"}
          onClickSelect
        />
        {showAddEditEntryTemplateDialog && (
          <CustomForm
            mode="dialog"
            currState={addEditEntryTemplateFormState}
            fieldsData={addEditEntryTemplateData}
            formSchema={addEditEntryTemplateFormSchema}
            closeDialog={this.closeDialog}
            customComponentBottom={
              <Fragment>
                <SpinnerLoader spinnerLoading={this.state.showloader} />
                <AddHosEntries
                  timezone={this.props.timezone}
                  hq={this.props.hq}
                  currentHosRecords={hosRecords}
                  pendingChanges={pendingChanges}
                  updateHosRecords={(records) =>
                    this.setState({
                      hosRecords: records,
                      pendingChanges: true,
                    })
                  }
                  disabled={addEditEntryTemplateFormState === "delete" || addEditEntryTemplateFormState === "view"}
                />
              </Fragment>
            }
            parentRef={{
              saveTemplate: (submission) => this.stateChangeReducer("add-entry-template", submission),
              updateTemplate: (submission) => this.stateChangeReducer("update-entry-template", submission),
              cancelTemplateDialog: (submission) => this.stateChangeReducer("discard-session", submission),
              confirmDeleteTemplate: () => this.stateChangeReducer("confirm-delete-entry-template"),
            }}
          />
        )}
      </div>
    );
  }
}

let variableList = {};
let reducers = [];

let actionOptions = {
  read: true,
  create: true,
  update: true,
  delete: true,
  others: {},
};

const EntryTemplatesContainer = CRUDFunction(
  EntryTemplates,
  "entryTemplate",
  actionOptions,
  variableList,
  reducers,
  "hoursofservice/entrytemplate",
);

export default EntryTemplatesContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/EntryTemplates/index.jsx